<template>
  <div class="three">
    <div class="title">
      <div class="left-box"></div>
      <div class="right-box">报修量&满意度分析</div>
    </div>
    <div class="main" id="main-info1"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: "",
      data: {
        begin: "2018-01-01 00:00:00",
        end: "3000-01-01 00:00:00",
      },
      xAxisArr: [],
      yAxisArr: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      $utils.api.load("StateWorkType", this.data, "get").then((res) => {
        console.log(res);
        let that = this;
        if (res.code == 200) {
          that.xAxisArr = [];
          that.yAxisArr = [];
          res.data.forEach((res) => {
            that.xAxisArr.push(res.title);
            that.yAxisArr.push(res.totle);
          });
          this.echartsFun();
        }
      });
    },
    echartsFun() {
      let chartMain = document.getElementById("main-info1");
      this.myChart = echarts.init(chartMain);
      let option = {
        grid: {
          left: "3%",
          right: "4%",
          top: "15%",
          bottom: "8%",
        },
        legend: {
          data: ["报修量", "满意度"],
          right: "10%",
          itemWidth: 50,
          itemHeight: 25,
        },
        xAxis: {
          type: "category",
          data: [
            "2022年8月",
            "2022年9月",
            "2022年10月",
            "2022年11月",
            "2022年12月",
            "2023年1月",
            "2023年2月",
            "2023年3月",
            "2023年4月",
            "2023年5月",
            "2023年6月",
            "2023年7月",
            "2023年8月",
          ],
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#999",
            },
          },
          axisLabel: {
            interval: 0,
            fontSize: 14,
            color: "#000",
            margin: 0,
            padding: [8, 0, 0, 0],
          },
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 800,
            interval: 100,
            axisLabel: {
              color: "#666",
              verticalAlign: "middle",
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dotted",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          {
            type: "value",
            min: 0,
            max: 100,
            interval: 10,
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "报修量",
            data: [120, 281, 423, 520, 575, 536, 651, 680, 584, 545, 490, 475, 473],
            type: "bar",
            barMaxWidth: 85,
            label: {
              show: true,
              position: "insideBottom",
              formatter: "{c}",
              color: "#fff",
              fontWeight: "bold",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(64, 158, 255, 0.1)" },
                { offset: 0.5, color: "rgba(64, 158, 255, 0.5)" },
                { offset: 1, color: "rgba(64, 158, 255, 1)" },
              ]),
            },
          },
          {
            name: "满意度",
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: "top",
              formatter: "{c}%",
            },
            data: [34, 45, 61, 75, 83, 85, 88, 93, 95, 94, 98, 99, 99],
          },
        ],
      };
      option && this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.three {
  width: 100%;
  height: 700px;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .left-box {
      width: 10px;
      height: 20px;
      border-radius: 1px;
      margin-right: 8px;
      background-color: #46a6ff;
    }

    .right-box {
      font-weight: 600;
      color: black;
    }
  }

  .main {
    width: 100%;
    height: 600px;
    background: #fff;
  }
}

.ivu-radio-group-button-solid
  .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled) {
  background: #46a6ff;
  color: #fff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked {
  border-color: #46a6ff;
  box-shadow: -1px 0 0 0 #46a6ff;
  z-index: 1;
}

.ivu-radio-group-button .ivu-radio-wrapper:hover {
  position: relative;
  color: #46a6ff;
}

.ivu-radio-group-button-solid
  .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled):hover {
  background: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:hover {
  border-color: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus {
  box-shadow: none;
  transition: none;
}

.iwu-btn-primary:focus {
  box-shadow: none;
}

.ivu-btn:focus {
  box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:before {
  background: none;
  opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
  transition: none;
}

.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
  opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child {
  border: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child {
  box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:after {
  opacity: 0;
}
</style>
